import { render, staticRenderFns } from "./SPicker.vue?vue&type=template&id=b322ba24&scoped=true"
import script from "./SPicker.vue?vue&type=script&lang=js"
export * from "./SPicker.vue?vue&type=script&lang=js"
import style0 from "./SPicker.vue?vue&type=style&index=0&id=b322ba24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b322ba24",
  null
  
)

export default component.exports